import { translations_sex_umfrage } from "./translation_strings"

var lang = 'de'

var translations: {
  [key: string]: { [key: string]: string }
} = translations_sex_umfrage

export function _t(prop: string) {
  if (!translations[prop]) {
    console.error(`Translation not found for ${prop}`,translations)
    return prop
  }
  if (!translations[prop][lang]) {
    console.error(`Translation not found for ${prop} in language ${lang}`,translations)
    return prop + ' (' + lang + ')'
  }
  return translations[prop][lang]
}

export function setTranslations(t: {
  [key: string]: { [key: string]: string }
}) {
  translations = t
}

export function setLanguage(l: string) {
  lang = l
}
